import React, { Component } from 'react';
import { connect } from 'react-redux';
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";
import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}


class PatientManagment extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        return (
            <div className="">
              <Helmet>
                    <title>Patient Management System & Digital EMR Software | KlinicQ</title>
                    <meta 
                        name="description" 
                        content="Digitize patient records, appointments, and communication with KlinicQ’s patient management software. Improve patient experience with secure, cloud-based EMR." 
                    />
                     <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "KlinicQ Patient Management System",
      "url": "https://www.klinicq.com/patientmanagement",
      "description": "Patient management system and digital EMR software for clinics and hospitals to manage patient records, appointments, communication, and clinical workflows securely in the cloud.",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web-based",
      "publisher": {
        "@type": "Organization",
        "name": "KlinicQ",
        "url": "https://www.klinicq.com"
      }
    }
    `}
  </script>
                </Helmet>

                <div className="">
                  
                    <div className="">
                

<div className='product-section'>
    <Headerweb/>
            {/* <hr className='m-0' style={{ color: '#D9F4FF' }} /> */}
 <section id="pharma-hero-section">
  <div className="pharma-hero-background">
    <div className="patientmang-hero-gradient"></div>
    <img
      src={require("../../src/assets/images/website/patient-management-software-healthcare-hero.webp")}
      alt="Patient management system software for hospitals and clinics by KlinicQ"
      className="pharma-hero-bg-image"
    />
  </div>
  <div className="pharma-container pharma-hero-content-container">
    <div className="pharma-hero-text">
      <h1>Patient Management System</h1>
      <p>
       The Patient Management module simplifies the entire lifecycle of patient care—from registration and appointment booking to medical history tracking and discharge summaries. Designed for speed and clarity, it ensures that healthcare staff can access and update patient records with minimal clicks and maximum accuracy.
      </p>
    </div>
   
  </div>
</section>

    <section id="hospitalmang-feature-one">
  <div class="hospitalmang-main-container">
    <div class="hospitalmang-feature-block">
      <div class="hospitalmang-feature-image-wrapper">
        <img src={require("../../src/assets/images/website/patient-records-management-system-healthcare.webp")} alt="Patient portal dashboard for medical records and appointment management in KlinicQ" />
      </div>
     <div class="hospitalmang-feature-text-wrapper">
  <p>
    The patient portal is designed to manage primary and family members under the same account with unique ID for each member. Patients can access their health history, medical records, and discharge summary and communicate with doctors and hospitals anytime & anywhere. Patients' Personal Identification Information (PII) and Patient Health Information (PHI) is encrypted as per HIPAA guidelines for data privacy & security.
  </p>
  <p>
    KlinicQ application's Patient module allows booking, rescheduling, or canceling appointments through mobile apps to reduce no-shows. If a patient is running late, the system automatically provides grace time and adjusts the schedule to avoid long waiting room delays.
  </p>
  <p>
    Patients can search hospitals or clinics in our network based on various filters like doctor specialty, hospital name, gender, city, and distance from their location. The KlinicQ application is integrated with Google Maps to show live waiting time data for nearby hospitals and update users with travel distance to the healthcare provider's location.
  </p>
  <p>
    For pregnant women, children, physically challenged, and elderly patients, waiting in crowded rooms can be distressing and risky. More crowds in the waiting room cause mental trauma and increase the risk of airborne diseases. KlinicQ's Token Management System algorithm allocates appointment times for each token, allowing visitors to arrive just before their scheduled time. This minimizes waiting room congestion, promotes social distancing, and helps reduce the spread of airborne illnesses.
  </p>
</div>

    </div>
  </div>
</section>

<section id="hospitalmang-feature-two">
  <div class="hospitalmang-main-container">
    <div class="hospitalmang-feature-block">
      <div class="hospitalmang-feature-text-wrapper">
  <p>
    The KlinicQ application is user-friendly, easy to navigate, and allows patients to check doctor availability with accurate wait times. It ensures data security and confidentiality, sending appointment confirmations and follow-up notifications to reduce no-shows.
  </p>
  <p>
    KlinicQ also supports online consultations via video calling, enabling patients who cannot visit the hospital or clinic to connect with available doctors remotely. Patients can mark their favorite healthcare providers for quicker appointment booking.
  </p>
  <p>
    Medical records such as prescriptions, discharge summaries, and vital details from previous consultations can be scanned or uploaded as images. This digital access helps doctors review complete patient history for more effective treatment.
  </p>
  <p>
    Additional features include general health tips, BMI tracking, and vital statistics. The application supports online payments through a secure gateway, QR code-based touchless check-in, and is available on both iOS and Android platforms.
  </p>
  <p>
  The application also includes a built-in notification center that alerts users about upcoming health camps, vaccination drives, and seasonal health advisories. This proactive engagement helps patients stay informed and encourages preventive care.
</p>

  <p>
    KlinicQ offers multilingual support with five language options: English, Tamil, Hindi, Telugu, and Kannada, making healthcare access more inclusive and convenient for diverse users.
  </p>
</div>

      <div class="hospitalmang-feature-image-wrapper">
        <img src={require("../../src/assets/images/website/digital-patient-management-healthcare-platform.webp")} alt="Digital patient consultation and healthcare management using KlinicQ platform" />
      </div>
    </div>
  </div>
</section>

 <div className='single-click py-5'>
          <div className='container'>
            <div className='row m-0'>
              {/* <div className='col-lg-4 col-12 mb-lg-0 mb-3 slide-left visible'>
                
              </div> */}
              <div className='col-lg-12 col-12 py-lg-0 py-md-0 py-2 slide-right visible text-center'>

              <h3>Expert Care, Anytime, Anywhere </h3>
                <p>Experience healthcare on your terms. Access licensed doctors instantly for personalized advice and seamless health management, wherever you are. Say goodbye to waiting rooms and rigid appointments – your health is now in your hands.</p>
              </div>
                     <div className="image-container1">
    {/* <img src={require("../../src/assets/images/website/Rectangle19.png")} className="background-image1" alt="Background" /> */}
    <img
        src={require("../../src/assets/images/website/Group76-1200.webp")}
        srcSet={`
            ${require("../../src/assets/images/website/Group76-768.webp")} 768w,
            ${require("../../src/assets/images/website/Group76-1200.webp")} 1200w,
            ${require("../../src/assets/images/website/Group76-1600.webp")} 1600w
        `}
        sizes="(max-width: 1200px) 100vw, 1053px"
        className="foreground-image1"
        alt="Online patient care and remote healthcare access through KlinicQ patient management system"
        loading="lazy"
        />

</div>
            </div>
          </div>
        </div>
        <div>
          </div>  
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
  
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(PatientManagment);